<template>
  <div class="ts-border ts-p-3 ts-rounded">
    <div class="row">
      <div class="col-md-6 ts-space-y-3">
        <div class="row">
          <label class="required form-col-label control-label col-md-3">{{
            $t('purchaseOrder.poDate')
          }}</label>
          <div class="col-md-7">
            <a-date-picker
              v-model="model.po_date"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              class="ts-w-full"
            />
            <div class="validate" v-if="errors.has('po_date')">
              {{ errors.first('po_date') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="required form-col-label control-label col-md-3">{{
            $t('purchaseOrder.vendor')
          }}</label>
          <div class="col-md-7">
            <a-select
              v-model="model.vendor_id"
              :options="supplierList"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              @change="onVendorChange"
              class="ts-w-full"
            ></a-select>
            <div class="validate" v-if="errors.has('vendor_id')">
              {{ errors.first('vendor_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3"></label>
          <div class="col-md-7">
            <div>
              {{ $t('wholesale.creditAmount') }} :
              <span class="ts-ml-3 ts-text-red-600">{{
                creditAmount
                  ? $defaultCurrencyWithCode(creditAmount, default_precision)
                  : 0
              }}</span>
            </div>
            <div class="ts-mt-3 ts-mb-0">
              {{ $t('wholesale.creditDay') }} :
              <input
                v-model.number="model.credit_day"
                type="number"
                class="ts-ml-3 ts-p-1 ts-border ts-outline-none"
                style="border-radius: 4px; width: 150px"
              />
              <div class="validate" v-if="errors.has('credit_day')">
                {{ errors.first('credit_day') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 ts-space-y-3">
        <div class="row">
          <label class="form-col-label control-label col-md-3">{{
            $t('purchaseOrder.purchaseType')
          }}</label>
          <div class="col-md-7">
            <div class="ts-flex ts-items-center">
              <a-select
                v-model="model.purchase_type_id"
                :options="purchaseTypeList"
                showSearch
                :showArrow="false"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                class="ts-w-full"
              ></a-select>
              <a
                href="#"
                @click.prevent="() => (add_new_purchase_type = true)"
                v-tooltip="$t('add_new')"
                class="ts-bg-blue-500 ts-h-8 ts-w-8 ts-text-white ts-flex ts-items-center ts-rounded-tr ts-rounded-br hover:ts-text-white"
                ><i class="fas fa-plus-square ts-mx-auto"></i
              ></a>
            </div>
            <div class="validate" v-if="errors.has('purchase_type_id')">
              {{ errors.first('purchase_type_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">{{
            $t('purchaseOrder.reference#')
          }}</label>
          <div class="col-md-7">
            <input
              v-model="model.reference_no"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">{{
            $t('purchaseOrder.description')
          }}</label>
          <div class="col-md-7">
            <textarea
              v-model="model.description"
              rows="3"
              class="form-control ts-w-full"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
    <!-- Purchase Type -->
    <a-modal
      :title="$t('purchaseOrder.createPurchaseType')"
      width="30%"
      v-model="add_new_purchase_type"
      :footer="null"
    >
      <div class="row">
        <label class="form-col-label control-label col-md-12 required">{{
          $t('purchaseOrder.purchaseType')
        }}</label>
        <div class="col-md-12">
          <input
            v-model="purchase_type_model.purchase_type"
            type="text"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('purchase_type')">
            {{ errors.first('purchase_type') }}
          </div>
        </div>
      </div>
      <div class="row ts-mt-4">
        <div
          class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end"
        >
          <ts-button @click.prevent="() => (add_new_purchase_type = false)">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            :waiting="waiting_new_purchase_type"
            @click.prevent="onSave"
            color="primary"
            >{{ $t('save') }}</ts-button
          >
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'purchaseInfo',
  props: ['value', 'validate'],
  data() {
    return {
      loading: false,
      waiting_new: false,
      waiting_new_purchase_type: false,
      waiting: false,
      add_new_purchase_type: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {},
      purchase_type_model: {
        purchase_type: null
      }
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    supplierList() {
      return this.$store.state.purchaseOrder.order.suppliers.map(el => ({
        value: el.vendor_id,
        label: el.vendor_name,
        credit_day: el.credit_day,
        credit_amount: el.credit_amount
      }))
    },
    purchaseTypeList() {
      return this.$store.state.purchaseOrder.order.purchaseTypes.map(el => ({
        value: el.purchase_type_id,
        label: el.purchase_type
      }))
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    },
    creditAmount() {
      let vendor = this.supplierList.find(v => v.value == this.model.vendor_id)
      if (vendor) {
        return vendor.credit_amount
      }
      return 0
    }
  },
  methods: {
    onVendorChange(value, opt) {
      this.model.credit_day = opt.data.props.credit_day
    },
    onSave() {
      this.waiting_new_purchase_type = true
      this.errors = new Errors()
      this.$store
        .dispatch('purchaseOrder/purchaseType/store', this.purchase_type_model)
        .then(async response => {
          this.$toasted.success(response.message)
          await this.$store.commit(
            'purchaseOrder/order/PUSH_NEW_PURCHASE_TYPE',
            response.data
          )
          this.model.purchase_type_id = response.data.purchase_type_id
          this.purchase_type_model.purchase_type = ''
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new_purchase_type = false
        })
    },
    clearInput() {
      this.model.po_date = moment().format('DD-MM-YYYY')
      this.model.vendor_id = null
      this.model.description = null
      this.model.reference_no = null
      this.model.purchase_type_id = null
      this.model.credit_day = 0
      this.model.po_detail = []

      this.purchase_type_model.purchase_type = null
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseOrder/order/CLEAR_SETUP')
    next()
  }
}
</script>
